import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState } from "@nosto/preact"

export default function Products() {
    const {
        response: { products },
        loading
    } = useAppState()

    return (
        <div class="grid-outer">
            <div class="grid">
                {products.hits.map((hit, index) => {
                    return <Product product={hit} key={hit.productId || index} />
                })}
            </div>
        </div>
    )
}
